import React from "react";
import { Col, Typography } from "antd";

import * as classes from "./SkillCourseCertificate.module.scss";
import tickIcon from "../images/tickIconYellow.svg";
import { SKILL_COURSE_PAGE_FILES_PATH } from "../../../utils/localization";

const { Title } = Typography;

const certificateDetails = [
  "Access to 150+ courses",
  "Self-paced learning",
  "Community access",
];

const SkillCourseCertificate = () => {
  return (
    <Col className={classes.certificateContainer}>
      <Col className={classes.wrapper}>
        <Col className={classes.certificateContent}>
          <Col className={classes.certificateContentLeft}>
            <Title className={classes.headingDesktop}>
              Start
              <br />
              <span>Exploring</span>
              <br />
              <span>Today</span>
            </Title>
            <Title className={classes.headingMobile}>
              Start&nbsp;<span>Exploring</span>
              &nbsp;<span>Today</span>
            </Title>
          </Col>
          <Col className={classes.certificateContentMiddle}>
            {certificateDetails.map((item) => (
              <Col key={item} className={classes.detailItem}>
                <img
                  src={tickIcon}
                  alt="A dinosaur"
                  className={classes.tickIcon}
                />
                <Title className={classes.title}>{item}</Title>
              </Col>
            ))}
          </Col>
          <Col className={classes.certificateContentRight}>
            <Title className={classes.title}>Your Certificate</Title>
            <Col className={classes.certificateImageContainer}>
              <img
                src={`${SKILL_COURSE_PAGE_FILES_PATH}/certificate-skill-course.png`}
              />
            </Col>
          </Col>
        </Col>
      </Col>
    </Col>
  );
};

export default SkillCourseCertificate;
